<template>
  <div
    v-if="!isMobile"
    class="nav-menu"
  >
    <div class="container nav-logo">
      <div>
        <router-link :to="{ name: 'Home' }">
          <img
            class="logo"
            src="../assets/Z1-W.svg"
          >
        </router-link>
      </div>
      <div class="nav-items">
        <slot />
        <div
          v-if="user"
          class="grid-content nav-new-ad"
        >
          <router-link
            :to="{ name: 'CreateAd' }"
            tag="el-button"
            class="nav-new-ad"
          >
            {{ $t('header.button.create-ad') }}
          </router-link>
        </div>
        <lang />
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */

import { mapState } from 'vuex';
import Lang from '../components/Lang';

export default {
  components: {
    // MenuItem,
    Lang,
  },
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1',
    };
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      user: state => state.auth.user,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/NavMenu.vue